// import Definition from './Definition';

export default {
  // component: Definition,
  component: load(() => import(/* webpackChunkName: "Permission-Role-Definition" */ './Definition')),
  priority: 11,
  permissions: ['BasicInformationMenu/Permissions/RolesMenu/PermissionsDefinitionMenu'],
  name: app.translate('routes.home.basic.permission.Definition'),
  icon: 'content-paste',
  drawer: true,
};
